import React from 'react';
import './Header.css'

const Header = (props) => {
	return (
		<header>
			<h1>TUNR.</h1>
			<p className='tagline'>FOR ALL YOUR PLAYLIST NEEDS</p>
		</header>
	);
};

export default Header;
